export default __webpack_public_path__ + "static/media/furniture15.9d814fff.jpeg";